// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","custom-context-menu_wrap":"CustomContextMenuPopup_custom-context-menu_wrap__NwLPm"};